import React, {Component} from "react";
import {Route, Switch, Redirect} from 'react-router-dom';
import * as LoadScript from 'react-load-script';

import ScrollToTop from './ScrollToTop';
import LoginPage from 'views/LoginPage';
import SignUpPage from 'views/SignUpPage';
import ProfilePage from 'views/ProfilePage';
import CreatePollPage from 'views/CreatePoll';
import SearchPage from 'views/SearchPage';
import PageNotFound from 'views/PageNotFound';
import TermsConditions from 'views/TC';
import Privacy from 'views/PP';
import Patents from 'views/Patents';
import Trending from 'views/Trending';
import PollTemplate from 'views/PollTemplate/PollTemplate';
import PollPreview from 'views/PollTemplate/PollPreview';

class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addThisLoaded: false,
    }
  }

  handleScriptLoad() {
    // console.log('<><> add this script loaded!');
    this.setState({ addThisLoaded: true });
    window.addthis.init();
    // window.addthis.layers.refresh();
    // window.addthis.toolbox('.addthis_inline_share_toolbox');
  }

  render() {
    const curLoc = window.location.pathname;
    const isRedirect = (curLoc !== '/404');
    // const homePageUrl = "what-is-your-fav-website-1YzP180";
    const homePageUrl = "which-technology-trend-will-have-the-greatest-impact-8olonqj";

    return (

      <ScrollToTop>
        <LoadScript
          url="https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5dfc06ae4bfe0783"
          onLoad={this.handleScriptLoad.bind(this)}
        />
        <Switch>
         <Route path="/terms-and-conditions" component={TermsConditions} />
         <Route path="/privacy-policy" component={Privacy} />
         <Route path="/trending-polls" component={Trending} />
         <Route path="/patents" component={Patents} />
         <Route path="/user/login" component={LoginPage} />
         <Route path="/user/signup" component={SignUpPage} />
         {/* NOTE TODO REDO AUTH FOR USER PAGE <Route path="/user/:username" component={UserIsAuthenticated(ProfilePage)} /> */}
         <Route path="/user/:username" component={ProfilePage} />
         <Route path="/poll/search" component={SearchPage} />
         <Route path="/poll/create" component={CreatePollPage} />
         <Route path="/poll/preview" component={PollPreview} />
         {/* <Route path="/poll/:pollid" component={PollTemplate} /> */}
         <Route path="/poll/:pollid"
            render={routeProps => (
              <PollTemplate {...routeProps} addThisLoaded={this.state.addThisLoaded} />
            )}
         />
         {/* <Route path="*" component={PageNotFound} /> */}
         <Route path="/404" render={() => <PageNotFound isRedirect={isRedirect} />}/>
         {/* <Redirect exact from="/" to="/poll/what-is-your-fav-website-1YzP180" /> */}
         <Route path="/" render={() =>
           <PollTemplate onReload={true} homeUrl={homePageUrl} addThisLoaded={this.state.addThisLoaded} />}
         />
         <Redirect to={{pathname: "/404", state:{from: curLoc} }}/>
        </Switch>
      </ScrollToTop>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.js